// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Core__Int from "@rescript/core/src/Core__Int.bs.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Array from "@rescript/core/src/Core__Array.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as PostalCodes$OrcaPaymentPage from "../utils/PostalCodes.bs.js";
import * as CpfValidation$OrcaPaymentPage from "./CpfValidation.bs.js";
import * as CnpjValidation$OrcaPaymentPage from "./CnpjValidation.bs.js";
import * as CountryStateDataHookTypes$OrcaPaymentPage from "../types/CountryStateDataHookTypes.bs.js";

var defaultCardPattern_pattern = /^[0-9]/;

var defaultCardPattern_cvcLength = [
  3,
  4
];

var defaultCardPattern_length = [
  13,
  14,
  15,
  16,
  17,
  18,
  19
];

var defaultCardPattern = {
  issuer: "",
  pattern: defaultCardPattern_pattern,
  cvcLength: defaultCardPattern_cvcLength,
  length: defaultCardPattern_length,
  maxCVCLength: 4,
  pincodeRequired: false
};

var cardPatterns = [
  {
    issuer: "Maestro",
    pattern: /^(5018|5081|5044|504681|504993|5020|502260|5038|5893|603845|603123|6304|6759|676[1-3]|6220|504834|504817|504645|504775|600206|627741)/,
    cvcLength: [
      3,
      4
    ],
    length: [
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19
    ],
    maxCVCLength: 4,
    pincodeRequired: true
  },
  {
    issuer: "UnionPay",
    pattern: /^(6[27]|81)/,
    cvcLength: [3],
    length: [
      16,
      17,
      18,
      19
    ],
    maxCVCLength: 3,
    pincodeRequired: true
  },
  {
    issuer: "Interac",
    pattern: /^(4506|4724|4761|0012)/,
    cvcLength: [3],
    length: [16],
    maxCVCLength: 3,
    pincodeRequired: true
  },
  {
    issuer: "RuPay",
    pattern: /^(508227|508[5-9]|603741|60698[5-9]|60699|607[0-8]|6079[0-7]|60798[0-4]|60800[1-9]|6080[1-9]|608[1-4]|608500|6521[5-9]|652[2-9]|6530|6531[0-4]|817290|817368|817378|353800|82)/,
    cvcLength: [3],
    length: [16],
    maxCVCLength: 3,
    pincodeRequired: false
  },
  {
    issuer: "DinersClub",
    pattern: /^(36|38|39|30[0-5])/,
    cvcLength: [3],
    length: [
      14,
      15,
      16,
      17,
      18,
      19
    ],
    maxCVCLength: 3,
    pincodeRequired: false
  },
  {
    issuer: "Discover",
    pattern: /^(6011|64[4-9]|65|622126|622[1-9][0-9][0-9]|6229[0-1][0-9]|622925)/,
    cvcLength: [3],
    length: [16],
    maxCVCLength: 3,
    pincodeRequired: true
  },
  {
    issuer: "Mastercard",
    pattern: /^(222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[0-1][0-9]|2720|5[1-5])/,
    cvcLength: [3],
    length: [16],
    maxCVCLength: 3,
    pincodeRequired: true
  },
  {
    issuer: "AmericanExpress",
    pattern: /^3[47]/,
    cvcLength: [4],
    length: [
      14,
      15
    ],
    maxCVCLength: 4,
    pincodeRequired: true
  },
  {
    issuer: "Visa",
    pattern: /^4/,
    cvcLength: [3],
    length: [
      13,
      14,
      15,
      16,
      19
    ],
    maxCVCLength: 3,
    pincodeRequired: true
  },
  {
    issuer: "CartesBancaires",
    pattern: /^(401(005|006|581)|4021(01|02)|403550|405936|406572|41(3849|4819|50(56|59|62|71|74)|6286|65(37|79)|71[7])|420110|423460|43(47(21|22)|50(48|49|50|51|52)|7875|95(09|11|15|39|98)|96(03|18|19|20|22|72))|4424(48|49|50|51|52|57)|448412|4505(19|60)|45(33|56[6-8]|61|62[^3]|6955|7452|7717|93[02379])|46(099|54(76|77)|6258|6575|98[023])|47(4107|71(73|74|86)|72(65|93)|9619)|48(1091|3622|6519)|49(7|83[5-9]|90(0[1-6]|1[0-6]|2[0-3]|3[0-3]|4[0-3]|5[0-2]|68|9[256789]))|5075(89|90|93|94|97)|51(0726|3([0-7]|8[56]|9(00|38))|5214|62(07|36)|72(22|43)|73(65|66)|7502|7647|8101|9920)|52(0993|1662|3718|7429|9227|93(13|14|31)|94(14|21|30|40|47|55|56|[6-9])|9542)|53(0901|10(28|30)|1195|23(4[4-7])|2459|25(09|34|54|56)|3801|41(02|05|11)|50(29|66)|5324|61(07|15)|71(06|12)|8011)|54(2848|5157|9538|98(5[89]))|55(39(79|93)|42(05|60)|4965|7008|88(67|82)|89(29|4[23])|9618|98(09|10))|56(0408|12(0[2-6]|4[134]|5[04678]))|58(17(0[0123457]|15|2[14]|3[16789]|4[0-9]|5[016]|6[269]|7[3789]|8[012467]|9[017])|55(0[2-5]|7[7-9]|8[0-2])))/,
    cvcLength: [3],
    length: [
      16,
      17,
      18,
      19
    ],
    maxCVCLength: 3,
    pincodeRequired: true
  },
  {
    issuer: "SODEXO",
    pattern: /^(637513)/,
    cvcLength: [3],
    length: [16],
    maxCVCLength: 3,
    pincodeRequired: false
  },
  {
    issuer: "BAJAJ",
    pattern: /^(203040)/,
    cvcLength: [3],
    length: [16],
    maxCVCLength: 3,
    pincodeRequired: true
  },
  {
    issuer: "JCB",
    pattern: /^35(2[89]|[3-8][0-9])/,
    cvcLength: [3],
    length: [16],
    maxCVCLength: 3,
    pincodeRequired: false
  }
];

function toInt(val) {
  return Core__Option.getOr(Core__Int.fromString(val, undefined), 0);
}

function clearSpaces(value) {
  return value.replace(/\D+/g, "");
}

function clearAlphas(value) {
  return value.replace(/[^\d\s]+/g, "");
}

function slice(val, start, end) {
  return val.slice(start, end);
}

function containsOnlyDigits(text) {
  return /^[0-9]*$/.test(text);
}

function containsDigit(text) {
  var match = text.match(/\d/);
  return !(match == null);
}

function containsMoreThanTwoDigits(text) {
  var matches = text.match(/\d/g);
  if (matches == null) {
    return false;
  } else {
    return matches.length > 2;
  }
}

function cardType(val) {
  var match = val.toUpperCase();
  switch (match) {
    case "AMEX" :
        return "AMEX";
    case "BAJAJ" :
        return "BAJAJ";
    case "CARTESBANCAIRES" :
        return "CARTESBANCAIRES";
    case "DINERSCLUB" :
        return "DINERSCLUB";
    case "DISCOVER" :
        return "DISCOVER";
    case "INTERAC" :
        return "INTERAC";
    case "JCB" :
        return "JCB";
    case "MAESTRO" :
        return "MAESTRO";
    case "MASTERCARD" :
        return "MASTERCARD";
    case "RUPAY" :
        return "RUPAY";
    case "SODEXO" :
        return "SODEXO";
    case "UNIONPAY" :
        return "UNIONPAY";
    case "VISA" :
        return "VISA";
    default:
      return "NOTFOUND";
  }
}

function getobjFromCardPattern(cardBrand) {
  return Core__Option.getOr(cardPatterns.filter(function (item) {
                    return cardBrand === item.issuer;
                  })[0], defaultCardPattern);
}

function getAllMatchedCardSchemes(cardNumber) {
  return Core__Array.reduce(cardPatterns, [], (function (acc, item) {
                if (Core__Option.isSome(Caml_option.nullable_to_opt(cardNumber.match(item.pattern)))) {
                  acc.push(item.issuer);
                }
                return acc;
              }));
}

function isCardSchemeEnabled(cardScheme, enabledCardSchemes) {
  return enabledCardSchemes.includes(cardScheme);
}

function getFirstValidCardScheme(cardNumber, enabledCardSchemes) {
  var allMatchedCards = getAllMatchedCardSchemes(clearSpaces(cardNumber));
  return Core__Option.getOr(allMatchedCards.find(function (card) {
                  return enabledCardSchemes.includes(card);
                }), "");
}

function getEligibleCoBadgedCardSchemes(matchedCardSchemes, enabledCardSchemes) {
  return matchedCardSchemes.filter(function (ele) {
              return enabledCardSchemes.includes(ele);
            });
}

function getCardBrand(cardNumber) {
  try {
    var card = cardNumber.replace(/[^\d]/g, "");
    var rupayRanges = [
      [
        508227,
        508227
      ],
      [
        508500,
        508999
      ],
      [
        603741,
        603741
      ],
      [
        606985,
        607384
      ],
      [
        607385,
        607484
      ],
      [
        607485,
        607984
      ],
      [
        608001,
        608100
      ],
      [
        608101,
        608200
      ],
      [
        608201,
        608300
      ],
      [
        608301,
        608350
      ],
      [
        608351,
        608500
      ],
      [
        652150,
        652849
      ],
      [
        652850,
        653049
      ],
      [
        653050,
        653149
      ],
      [
        817290,
        817290
      ],
      [
        817368,
        817368
      ],
      [
        817378,
        817378
      ],
      [
        353800,
        353800
      ]
    ];
    var masterCardRanges = [[
        222100,
        272099
      ]];
    var doesFallInRange = function (cardRanges, isin) {
      var intIsin = Core__Option.getOr(Core__Int.fromString(isin.replace(/[^\d]/g, "").substring(0, 6), undefined), 0);
      var range = cardRanges.map(function (currCardRange) {
            if (intIsin >= currCardRange[0]) {
              return intIsin <= currCardRange[1];
            } else {
              return false;
            }
          });
      return range.includes(true);
    };
    if (doesFallInRange(rupayRanges, card)) {
      return "RUPAY";
    } else if (doesFallInRange(masterCardRanges, card)) {
      return "MASTERCARD";
    } else {
      return Core__Option.getOr(cardPatterns.map(function (item) {
                          if (Core__Option.isSome(Caml_option.nullable_to_opt(card.match(item.pattern)))) {
                            return item.issuer;
                          } else {
                            return "";
                          }
                        }).filter(function (item) {
                        return item !== "";
                      })[0], "");
    }
  }
  catch (_error){
    return "";
  }
}

function calculateLuhn(value) {
  var card = clearSpaces(value);
  var splitArr = card.split("");
  splitArr.reverse();
  var unCheckArr = splitArr.filter(function (param, i) {
        return i % 2 === 0;
      });
  var checkArr = splitArr.filter(function (param, i) {
          return (i + 1 | 0) % 2 === 0;
        }).map(function (item) {
        var val = toInt(item);
        var $$double = (val << 1);
        if ($$double <= 9) {
          return $$double.toString();
        }
        var str = $$double.toString();
        var arr = str.split("");
        return (toInt(Core__Option.getOr(arr[0], "")) + toInt(Core__Option.getOr(arr[1], "")) | 0).toString();
      });
  var sumofCheckArr = Core__Array.reduce(checkArr, 0, (function (acc, val) {
          return acc + toInt(val) | 0;
        }));
  var sumofUnCheckedArr = Core__Array.reduce(unCheckArr, 0, (function (acc, val) {
          return acc + toInt(val) | 0;
        }));
  var totalSum = sumofCheckArr + sumofUnCheckedArr | 0;
  return totalSum % 10 === 0;
}

function maxCardLength(cardBrand) {
  var obj = getobjFromCardPattern(cardBrand);
  return Core__Array.reduce(obj.length, 0, (function (acc, val) {
                if (acc > val) {
                  return acc;
                } else {
                  return val;
                }
              }));
}

function cardValid(cardNumber, cardBrand) {
  var clearValue = clearSpaces(cardNumber);
  if (getobjFromCardPattern(cardBrand).length.includes(clearValue.length)) {
    return calculateLuhn(cardNumber);
  } else {
    return false;
  }
}

function isCardNumberEqualsMax(cardNumber, cardBrand) {
  var clearValue = clearSpaces(cardNumber);
  if (clearValue.length === maxCardLength(cardBrand)) {
    return true;
  } else {
    return clearValue.length === 16;
  }
}

function cvcNumberInRange(val, cardBrand) {
  var clearValue = clearSpaces(val);
  var obj = getobjFromCardPattern(cardBrand);
  return Core__Option.isSome(obj.cvcLength.find(function (item) {
                  return clearValue.length === item;
                }));
}

function cvcNumberEqualsMaxLength(val, cardBrand) {
  var clearValue = clearSpaces(val);
  var obj = getobjFromCardPattern(cardBrand);
  return clearValue.length === obj.maxCVCLength;
}

function checkMaxCardCvv(cvcNumber, cardBrand) {
  if (cvcNumber.length > 0) {
    return cvcNumberEqualsMaxLength(cvcNumber, cardBrand);
  } else {
    return false;
  }
}

function checkCardCVC(cvcNumber, cardBrand) {
  if (cvcNumber.length > 0) {
    return cvcNumberInRange(cvcNumber, cardBrand);
  } else {
    return false;
  }
}

function getCurrentMonthAndYear(dateTimeIsoString) {
  var tempTimeDateString = dateTimeIsoString.replace("Z", "");
  var tempTimeDate = tempTimeDateString.split("T");
  var date = Core__Option.getOr(tempTimeDate[0], "");
  var dateComponents = date.split("-");
  var currentMonth = Core__Option.getOr(dateComponents[1], "");
  var currentYear = Core__Option.getOr(dateComponents[0], "");
  return [
          toInt(currentMonth),
          toInt(currentYear)
        ];
}

function getStrFromIndex(arr, index) {
  return Core__Option.getOr(arr[index], "");
}

function splitExpiryDates(val) {
  var split = val.split("/");
  var value = split.map(function (item) {
        return item.trim();
      });
  var month = Core__Option.getOr(value[0], "");
  var year = Core__Option.getOr(value[1], "");
  return [
          month,
          year
        ];
}

function getExpiryDates(val) {
  var date = new Date().toISOString();
  var match = splitExpiryDates(val);
  var match$1 = getCurrentMonthAndYear(date);
  var prefix = match$1[1].toString().slice(0, 2);
  return [
          match[0],
          prefix + match[1]
        ];
}

function getExpiryValidity(cardExpiry) {
  var date = new Date().toISOString();
  var match = getExpiryDates(cardExpiry);
  var year = match[1];
  var month = match[0];
  var match$1 = getCurrentMonthAndYear(date);
  var currentYear = match$1[1];
  if (currentYear === toInt(year) && toInt(month) >= match$1[0] && toInt(month) <= 12) {
    return true;
  } else if (toInt(year) > currentYear && toInt(year) < 2099 && toInt(month) >= 1) {
    return toInt(month) <= 12;
  } else {
    return false;
  }
}

function checkCardExpiry(expiry) {
  if (expiry.length > 0) {
    return getExpiryValidity(expiry);
  } else {
    return false;
  }
}

function isEmailValid(email) {
  var _match = email.match(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
  if (_match == null) {
    if (email.length > 0) {
      return false;
    } else {
      return ;
    }
  } else {
    return true;
  }
}

function isValidZip(zipCode, country) {
  var postalCode = Core__Option.getOr(PostalCodes$OrcaPaymentPage.postalCode.find(function (item) {
            return item.iso === CountryStateDataHookTypes$OrcaPaymentPage.defaultTimeZone.country_code;
          }), PostalCodes$OrcaPaymentPage.defaultPostalCode);
  var isZipCodeValid = new RegExp(postalCode.regex).test(zipCode);
  if (zipCode.length > 0) {
    return isZipCodeValid;
  } else {
    return false;
  }
}

function isValidIban(text) {
  var trimmedText = text.trim();
  return trimmedText.length !== 0;
}

function formatCardNumber(val, cardType) {
  var clearValue = clearSpaces(val);
  var tmp;
  var exit = 0;
  switch (cardType) {
    case "AMEX" :
        tmp = clearValue.slice(0, 4) + " " + clearValue.slice(4, 10) + " " + clearValue.slice(10, 15);
        break;
    case "DINERSCLUB" :
        tmp = clearValue.length > 14 ? clearValue.slice(0, 4) + " " + clearValue.slice(4, 8) + " " + clearValue.slice(8, 12) + " " + clearValue.slice(12, 16) + "   " + clearValue.slice(16, 19) : clearValue.slice(0, 4) + " " + clearValue.slice(4, 10) + " " + clearValue.slice(10, 14);
        break;
    case "VISA" :
    case "MASTERCARD" :
    case "DISCOVER" :
    case "SODEXO" :
    case "RUPAY" :
        exit = 1;
        break;
    default:
      tmp = clearValue.slice(0, 4) + " " + clearValue.slice(4, 8) + " " + clearValue.slice(8, 12) + " " + clearValue.slice(12, 19);
  }
  if (exit === 1) {
    tmp = clearValue.slice(0, 4) + " " + clearValue.slice(4, 8) + " " + clearValue.slice(8, 12) + " " + clearValue.slice(12, 16) + " " + clearValue.slice(16, 19);
  }
  return tmp.trim();
}

function formatCVCNumber(val, cardType) {
  var clearValue = clearSpaces(val);
  var obj = getobjFromCardPattern(cardType);
  return clearValue.slice(0, obj.maxCVCLength);
}

function formatCardExpiryNumber(val) {
  var clearValue = clearSpaces(val);
  var expiryVal = toInt(clearValue);
  var formatted;
  if (expiryVal >= 2 && expiryVal <= 9 && clearValue.length === 1) {
    formatted = "0" + clearValue + " / ";
  } else if (clearValue.length === 2 && expiryVal > 12) {
    var val$1 = clearValue.split("");
    formatted = "0" + getStrFromIndex(val$1, 0) + " / " + getStrFromIndex(val$1, 1);
  } else {
    formatted = clearValue;
  }
  if (clearValue.length >= 3) {
    return formatted.slice(0, 2) + " / " + formatted.slice(2, 4);
  } else {
    return formatted;
  }
}

function isAtLeast18YearsOld(value) {
  var match = value.split("-");
  if (match.length !== 3) {
    return false;
  }
  var year = match[0];
  var month = match[1];
  var date = match[2];
  var dob = new Date(toInt(year), toInt(month) - 1 | 0, toInt(date));
  var now = new Date();
  var threshold = new Date(now.getFullYear() - 18 | 0, now.getMonth(), now.getDate());
  return dob.getTime() <= threshold.getTime();
}

function validateField(value, rules, enabledCardSchemes, localeObject) {
  return Core__Array.reduce(rules, undefined, (function (acc, rule) {
                if (acc !== undefined) {
                  return acc;
                }
                if (typeof rule !== "object") {
                  switch (rule) {
                    case "CardNumber" :
                        if (value.length === 0) {
                          return localeObject.cardNumberEmptyText;
                        }
                        var validCardBrand = getFirstValidCardScheme(value, enabledCardSchemes);
                        var cardBrand = validCardBrand === "" ? getCardBrand(value) : validCardBrand;
                        var formattedNumber = formatCardNumber(value, cardType(cardBrand));
                        if (cardValid(formattedNumber, cardBrand)) {
                          return ;
                        } else {
                          return localeObject.inValidCardErrorText;
                        }
                    case "Email" :
                        if (value.length === 0) {
                          return localeObject.emailEmptyText;
                        }
                        var match = isEmailValid(value);
                        if (match !== undefined && !match) {
                          return localeObject.emailInvalidText;
                        } else {
                          return ;
                        }
                    case "FirstName" :
                        var trimmedValue = value.trim();
                        if (trimmedValue.length < 1) {
                          return localeObject.cardHolderNameRequiredText;
                        } else if (containsDigit(trimmedValue)) {
                          return localeObject.invalidDigitsCardHolderNameError;
                        } else {
                          return ;
                        }
                    case "LastName" :
                        var trimmedValue$1 = value.trim();
                        if (trimmedValue$1.length < 1) {
                          return localeObject.lastNameRequiredText;
                        } else if (containsDigit(trimmedValue$1)) {
                          return localeObject.invalidDigitsCardHolderNameError;
                        } else {
                          return ;
                        }
                    case "Phone" :
                        var cleanPhone = clearSpaces(value);
                        if (cleanPhone.length < 10) {
                          return localeObject.phoneInvalidText;
                        } else {
                          return ;
                        }
                    case "IBAN" :
                        if (isValidIban(value)) {
                          return ;
                        } else {
                          return localeObject.ibanEmptyText;
                        }
                    case "BankAccountNumber" :
                        var cleanValue = clearSpaces(value);
                        if (cleanValue.length === 0) {
                          return localeObject.mandatoryFieldText;
                        } else if (!containsOnlyDigits(cleanValue) || cleanValue.length > 17) {
                          return localeObject.accountNumberInvalidText;
                        } else {
                          return ;
                        }
                    case "BlikCode" :
                        var digits = value.replace(/[^0-9]/g, "");
                        if (value.length === 0) {
                          return localeObject.mandatoryFieldText;
                        } else if (digits.length !== 6) {
                          return localeObject.blikCodeInvalidText;
                        } else {
                          return ;
                        }
                    case "GiftCardNumber" :
                    case "GiftCardPin" :
                        break;
                    case "Nickname" :
                        var digitMatches = value.match(/\d/g);
                        var digitCount = !(digitMatches == null) ? digitMatches.length : 0;
                        if (digitCount > 2) {
                          return localeObject.invalidNickNameError;
                        } else {
                          return ;
                        }
                    case "PixKey" :
                        if (value.length > 0) {
                          return ;
                        } else {
                          return localeObject.pixKeyEmptyText;
                        }
                    case "PixCPF" :
                        var isCPFValid = CpfValidation$OrcaPaymentPage.isValidCPF(value);
                        if (isCPFValid) {
                          return ;
                        } else if (value.length === 0) {
                          return localeObject.pixCPFEmptyText;
                        } else {
                          return localeObject.pixCPFInvalidText;
                        }
                    case "PixCNPJ" :
                        var isCNPJValid = CnpjValidation$OrcaPaymentPage.isValidCNPJ(value);
                        if (isCNPJValid) {
                          return ;
                        } else if (value.length === 0) {
                          return localeObject.pixCNPJEmptyText;
                        } else {
                          return localeObject.pixCNPJInvalidText;
                        }
                    case "RoutingNumber" :
                        var cleanValue$1 = clearSpaces(value);
                        if (cleanValue$1.length === 0) {
                          return localeObject.mandatoryFieldText;
                        }
                        if (cleanValue$1.length !== 9) {
                          return localeObject.formFieldInvalidRoutingNumber;
                        }
                        if (!containsOnlyDigits(cleanValue$1)) {
                          return localeObject.formFieldInvalidRoutingNumber;
                        }
                        var weights = [
                          3,
                          7,
                          1,
                          3,
                          7,
                          1,
                          3,
                          7,
                          1
                        ];
                        var sum = Core__Array.reduce(cleanValue$1.split("").map(function (item, i) {
                                  return Math.imul(toInt(item), Core__Option.getOr(weights[i], 3));
                                }), 0, (function (acc, val) {
                                return acc + val | 0;
                              }));
                        if (sum % 10 === 0) {
                          return ;
                        } else {
                          return localeObject.formFieldInvalidRoutingNumber;
                        }
                    case "DateOfBirth" :
                        if (value.trim().length === 0) {
                          return localeObject.dateofBirthRequiredText;
                        } else if (isAtLeast18YearsOld(value)) {
                          return ;
                        } else {
                          return localeObject.dateOfBirthInvalidText;
                        }
                    
                  }
                } else {
                  switch (rule.TAG) {
                    case "Required" :
                        var trimmedValue$2 = value.trim();
                        if (trimmedValue$2 === "") {
                          return Core__Option.getOr(rule._0, localeObject.mandatoryFieldText);
                        } else {
                          return ;
                        }
                    case "MinLength" :
                        var min = rule._0;
                        if (value.length < min) {
                          return "Minimum " + min.toString() + " characters required";
                        } else {
                          return ;
                        }
                    case "MaxLength" :
                        var max = rule._0;
                        if (value.length > max) {
                          return "Maximum " + max.toString() + " characters allowed";
                        } else {
                          return ;
                        }
                    case "CardExpiry" :
                        var value$1 = rule._0;
                        if (value$1.length === 0) {
                          return localeObject.cardExpiryDateEmptyText;
                        } else if (checkCardExpiry(value$1)) {
                          return ;
                        } else {
                          return localeObject.inValidExpiryErrorText;
                        }
                    case "CardCVC" :
                        if (value.length === 0) {
                          return localeObject.cvcNumberEmptyText;
                        } else if (checkCardCVC(value, rule._0)) {
                          return ;
                        } else {
                          return localeObject.inValidCVCErrorText;
                        }
                    case "CardNetwork" :
                        if (Core__Option.isSome(rule._0.find(function (v) {
                                    return v === value;
                                  }))) {
                          return ;
                        } else {
                          return localeObject.unsupportedCardErrorText;
                        }
                    case "PostalCode" :
                        if (isValidZip(value, rule._0)) {
                          return ;
                        } else {
                          return localeObject.postalCodeInvalidText;
                        }
                    case "Generic" :
                        if (value === "") {
                          return ;
                        }
                        var pattern = rule._0;
                        try {
                          var re = new RegExp(pattern);
                          if (re.test(value)) {
                            return ;
                          } else {
                            return localeObject.enterValidDetailsText;
                          }
                        }
                        catch (exn){
                          console.warn("Invalid regex pattern in Generic validator: \"" + pattern + "\", needs to be fixed for proper validation.");
                          return ;
                        }
                    
                  }
                }
                if (value.length === 0) {
                  return localeObject.mandatoryFieldText;
                }
                
              }));
}

function createFieldValidator(validationRules, enabledCardSchemes, localeObject) {
  return function (value) {
    return validateField(Core__Option.getOr(value, ""), validationRules, enabledCardSchemes, localeObject);
  };
}

function getKeyboardType(validationRule) {
  if (typeof validationRule !== "object") {
    switch (validationRule) {
      case "CardNumber" :
          return "numeric";
      case "Email" :
          return "email-address";
      case "Phone" :
          return "phone-pad";
      default:
        return "default";
    }
  } else {
    switch (validationRule.TAG) {
      case "CardExpiry" :
      case "CardCVC" :
          return "numeric";
      default:
        return "default";
    }
  }
}

function getSecureTextEntry(validationRule) {
  if (typeof validationRule !== "object" || validationRule.TAG !== "CardCVC") {
    return false;
  } else {
    return true;
  }
}

function format(value, validationRule) {
  var cardBrand = getCardBrand(value);
  if (typeof validationRule !== "object") {
    if (validationRule === "CardNumber") {
      return formatCardNumber(value, cardType(cardBrand));
    } else {
      return value;
    }
  }
  switch (validationRule.TAG) {
    case "CardExpiry" :
        var value$1 = validationRule._0;
        if (value$1.includes("/") || value$1.length <= 5) {
          return formatCardExpiryNumber(value$1);
        } else {
          return value$1.substring(0, 4);
        }
    case "CardCVC" :
        return formatCVCNumber(value, cardBrand);
    default:
      return value;
  }
}

function formatValue(validationRule) {
  return function (value, _name) {
    return Core__Option.map(value, (function (value) {
                  return format(value, validationRule);
                }));
  };
}

export {
  defaultCardPattern ,
  cardPatterns ,
  toInt ,
  clearSpaces ,
  clearAlphas ,
  slice ,
  containsOnlyDigits ,
  containsDigit ,
  containsMoreThanTwoDigits ,
  cardType ,
  getobjFromCardPattern ,
  getAllMatchedCardSchemes ,
  isCardSchemeEnabled ,
  getFirstValidCardScheme ,
  getEligibleCoBadgedCardSchemes ,
  getCardBrand ,
  calculateLuhn ,
  maxCardLength ,
  cardValid ,
  isCardNumberEqualsMax ,
  cvcNumberInRange ,
  cvcNumberEqualsMaxLength ,
  checkMaxCardCvv ,
  checkCardCVC ,
  getCurrentMonthAndYear ,
  getStrFromIndex ,
  splitExpiryDates ,
  getExpiryDates ,
  getExpiryValidity ,
  checkCardExpiry ,
  isEmailValid ,
  isValidZip ,
  isValidIban ,
  formatCardNumber ,
  formatCVCNumber ,
  formatCardExpiryNumber ,
  isAtLeast18YearsOld ,
  validateField ,
  createFieldValidator ,
  getKeyboardType ,
  getSecureTextEntry ,
  format ,
  formatValue ,
}
/* No side effect */
